import type { HubspotBackwardsSyncRequestType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useHubspotBackwardsSync = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: HubspotBackwardsSyncRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `hubspot/backwards-sync`,
        data: data,
      }).then((response) => response),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
